import { UserPen } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

function AssignPresentationButton({ presentationId }) {
  const navigate = useNavigate();

  const handlePreview = () => {
    navigate(`/assign-presentation/${presentationId}`);
  };
  return (
    <div>
      <button
        onClick={handlePreview}
        className="px-4 py-2 bg-yellow-500 text-sm text-white rounded-lg shadow hover:bg-yellow-600 hover:scale-105 transition flex gap-2 items-center"
      >
        <UserPen className="w-4 h-4" />
        <span>Assign to</span>
      </button>
    </div>
  );
}

export default AssignPresentationButton;
